export const errorCodes = {
  USER_STORE_LOADING: 'USER_STORE_LOADING',
  FETCH_CURRENT_USER: 'FETCH_CURRENT_USER',
  FETCH_BUCKET_STATS: 'FETCH_BUCKET_STATS',
  FETCH_RR_ANSWER_COUNTS: 'FETCH_RR_ANSWER_COUNTS',
  GET_ACCOUNT_INFO: 'GET_ACCOUNT_INFO',
  GET_JOB_APPLICATION: 'GET_JOB_APPLICATION',
  GET_FILTER_COUNTS: 'GET_FILTER_COUNTS',
  GET_CACHED_JOB_APPLICATIONS: 'GET_CACHED_JOB_APPLICATIONS',
  GET_EXPECTED_SALARY: 'GET_EXPECTED_SALARY',
  MARK_APPLICATIONS_READ: 'MARK_APPLICATIONS_READ',
  LEGACY_GET_JOB: 'LEGACY_GET_JOB',
  GET_JOB_DETAILS: 'GET_JOB_DETAILS',
  GET_QUESTIONNAIRE: 'GET_QUESTIONNAIRE',
  UPDATE_STATUS: 'UPDATE_STATUS',
  JOB_APPLICATION_LOAD_DETAILS: 'JOB_APPLICATION_LOAD_DETAILS',
  UNKNOWN_SORT_TYPE: 'UNKNOWN_SORT_TYPE',
  LOAD_NOTES: 'LOAD_NOTES',
  LOAD_ATTACHMENTS: 'LOAD_ATTACHMENTS',
  ADD_ATTACHMENT: 'ADD_ATTACHMENT',
  DELETE_ATTACHMENT: 'DELETE_ATTACHMENT',
  CREATE_NOTE: 'CREATE_NOTE',
  REMOVE_NOTE: 'REMOVE_NOTE',
  LOAD_EMAILS: 'LOAD_EMAILS',
  LOAD_CANDIDATE: 'LOAD_CANDIDATE',
  SEND_EMAIL: 'SEND_EMAIL',
  BULK_UPDATE_STATUS: 'BULK_UPDATE_STATUS',
  FETCH_PROSPECTS: 'FETCH_PROSPECTS',
  UPDATE_APPLICATIONS_STATUS: 'UPDATE_APPLICATIONS_STATUS',
  EASY_ACCESS: 'EASY_ACCESS',
  UPDATE_APPLICATION_RATING: 'UPDATE_APPLICATION_RATING',
  EXPORT_TO_CSV: 'EXPORT_TO_CSV',
  EXPIRE_JOB_AD: 'EXPIRE_JOB_AD',
  UPDATE_EXPIRY_DATE: 'UPDATE_EXPIRY_DATE',
  MANUALLY_ADD_CANDIDATE: 'MANUALLY_ADD_CANDIDATE',
  MANUALLY_ADD_CANDIDATE_CHECK_EMAIL: 'MANUALLY_ADD_CANDIDATE_CHECK_EMAIL',
  FETCH_PROFILE: 'FETCH_PROFILE',
  CAPTURE_EVENT: 'CAPTURE_EVENT',
  UPDATE_JOB_NOTIFICATIONS: 'UPDATE_JOB_NOTIFICATIONS',
  GET_JOB_NOTIFICATIONS: 'GET_JOB_NOTIFICATIONS',
  FETCH_ADVERTISER_JOB_ACCESS: 'FETCH_ADVERTISER_JOB_ACCESS',
  CHECK_AUTHENTICATION_GQL_UNAUTHENTICATED_ERROR:
    'CHECK_AUTHENTICATION_GQL_UNAUTHENTICATED_ERROR',
  CHECK_FORBIDDEN_GQL_FORBIDDEN_ERROR: 'CHECK_FORBIDDEN_GQL_FORBIDDEN_ERROR',
  CHECK_AUTHENTICATION_GQL_OTHER_ERROR: 'CHECK_AUTHENTICATION_GQL_OTHER_ERROR',
  CHECK_AUTHENTICATION_ERROR: 'CHECK_AUTHENTICATION_ERROR',
  NULL_TOKEN: 'NULL_TOKEN',
  CANT_FIND_PAGE_OF_APP: 'CANT_FIND_PAGE_OF_APP',
  FETCH_ACCESS_AND_JOB_INFORMATION: 'FETCH_ACCESS_AND_JOB_INFORMATION',
  INVALID_JOB_ID: 'INVALID_JOB_ID',
  SHOW_JOB_APPLICATION_DETAILS: 'SHOW_JOB_APPLICATION_DETAILS',
  NEGATIVE_BUCKET_COUNT: 'NEGATIVE_BUCKET_COUNT',
  EVENT_CAPTURE_API_ERROR: 'EVENT_CAPTURE_API_ERROR',
  ACTIONS_ROUTE_INVALID_ACTION: 'ACTIONS_ROUTE_INVALID_ACTION',
  ACTIONS_ROUTE_UPDATE_PROSPECT_STATUS: 'ACTIONS_ROUTE_UPDATE_PROSPECT_STATUS',
  LOGIN_WITH_REDIRECTION_URL: 'LOGIN_WITH_REDIRECTION_URL',
  EVENT_CAPTURE_MISSING_ADVERTISER_DATA:
    'EVENT_CAPTURE_MISSING_ADVERTISER_DATA',
  EVENT_CAPTURE_MISSING_JOB_ID: 'EVENT_CAPTURE_MISSING_JOB_ID',
  EVENT_CAPTURE_MISSING_POSITION_ID: 'EVENT_CAPTURE_MISSING_POSITION_ID',
  EVENT_CAPTURE_MISSING_LISTING_ID: 'EVENT_CAPTURE_MISSING_LISTING_ID',
  EVENT_CAPTURE_MISSING_SUMMARY_CANDIDATE_DATA:
    'EVENT_CAPTURE_MISSING_SUMMARY_CANDIDATE_DATA',
  EVENT_CAPTURE_MISSING_CANDIDATE_DATA: 'EVENT_CAPTURE_MISSING_CANDIDATE_DATA',
  INVALID_POSITION_LISTING_ID: 'INVALID_POSITION_LISTING_ID',
  GET_JOB: 'GET_JOB',
} as const;
